(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Iw-benefits"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-cta"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-faq"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  /* Theme Editor only: open a question while its block is selected. */
  (function () {
    'use strict';
    if (window.IWFaq) { return; }
    window.IWFaq = true;

    document.addEventListener('shopify:block:select', function (event) {
      if (event.target.classList.contains('iw-faq__item')) { event.target.open = true; }
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      var item = event.target;
      if (item.classList.contains('iw-faq__item') && !item.hasAttribute('data-iw-open')) { item.open = false; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-header"] && !Shopify.designMode) return;
  try {
    
  /* Header: publishes its height as --iw-header-h (used for anchor offsets and
     the pinned study figure) and closes the mobile menu on link tap, outside
     tap, or Escape. The menu itself is a native <details>, so it opens
     without JavaScript. */
  (function () {
    'use strict';
    if (window.IWHeader) { return; }
    window.IWHeader = true;

    var doc = document;

    function measure() {
      var header = doc.querySelector('.iw-header');
      if (!header) { return; }
      doc.documentElement.style.setProperty('--iw-header-h', Math.round(header.getBoundingClientRect().height) + 'px');
    }

    function closeMenus() {
      Array.prototype.forEach.call(doc.querySelectorAll('.iw-header__menu[open]'), function (menu) {
        menu.removeAttribute('open');
      });
    }

    doc.addEventListener('click', function (event) {
      var target = event.target;
      var menu = target.closest ? target.closest('.iw-header__menu') : null;
      if (!menu) { closeMenus(); return; }
      if (target.closest('a')) { menu.removeAttribute('open'); }
    });
    doc.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closeMenus(); }
    });

    measure();
    doc.addEventListener('DOMContentLoaded', measure);
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure, { passive: true });
    doc.addEventListener('shopify:section:load', measure);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-hero"] && !Shopify.designMode) return;
  try {
    
  /* Hero video: mobile browsers sometimes leave a muted autoplay video paused.
     Nudge it on load and again on the first interaction. */
  (function () {
    'use strict';
    if (window.IWHeroVideo) { return; }
    window.IWHeroVideo = true;

    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function play() {
      if (reduceMotion) { return; }
      Array.prototype.forEach.call(document.querySelectorAll('.iw-hero video[autoplay]'), function (video) {
        video.muted = true;
        video.setAttribute('playsinline', '');
        if (!video.paused) { return; }
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') { attempt.catch(function () {}); }
      });
    }

    play();
    document.addEventListener('DOMContentLoaded', play);
    window.addEventListener('load', play);
    document.addEventListener('shopify:section:load', play);
    ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (name) {
      window.addEventListener(name, play, { once: true, passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-image-band"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-manifesto"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-offer"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-problem"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-safety"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-science-cta"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-statement"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-stats"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-steps"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-story"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-study"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-study2"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-study3"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-study4"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-study5"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-study6"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Iw-study7"] && !Shopify.designMode) return;
  try {
    
  /* Scroll reveals: .iw-reveal gains .iw-in when it enters the viewport.
     Identical in every animated section; only the first copy runs. */
  (function () {
    'use strict';
    if (window.IWReady) { return; }
    window.IWReady = true;

    var doc = document;
    var root = doc.documentElement;
    var observer = null;
    var sweepQueued = false;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function each(list, fn) {
      Array.prototype.forEach.call(list || [], fn);
    }

    function show(el) {
      el.classList.add('iw-in');
    }

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) { return observer; }
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          show(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      return observer;
    }

    function watch(scope) {
      var io = reduceMotion ? null : getObserver();
      each((scope || doc).querySelectorAll('.iw-reveal:not(.iw-in)'), function (el) {
        if (io) { io.observe(el); } else { show(el); }
      });
    }

    /* Safety net: show anything already scrolled past (anchor jump, restored
       scroll position, fast fling) and anything on screen once the page cannot
       scroll further, so nothing is ever left hidden. */
    function sweep() {
      sweepQueued = false;
      var viewport = window.innerHeight || root.clientHeight;
      var pending = doc.querySelectorAll('.iw-reveal:not(.iw-in)');
      var last = pending.length ? pending[pending.length - 1].getBoundingClientRect() : null;
      /* "At the end" = the last hidden element is on screen but too low to
         cross the observer's trigger line. Works whichever element scrolls. */
      var atEnd = !!last && last.top < viewport && last.top > viewport * 0.9;
      each(pending, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || (atEnd && rect.top < viewport)) {
          show(el);
          if (observer) { observer.unobserve(el); }
        }
      });
    }

    function queueSweep() {
      if (sweepQueued) { return; }
      sweepQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(sweep, 16);
    }

    function start() {
      watch(doc);
      queueSweep();
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    /* Capture phase, so scrolling inside a wrapper (Horizon scrolls .page-wrapper
       on desktop, not the window) is seen as well. */
    doc.addEventListener('scroll', queueSweep, { passive: true, capture: true });

    /* Theme Editor: sections are re-rendered without a page load. */
    doc.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    doc.addEventListener('shopify:section:select', function (event) {
      each(event.target.querySelectorAll('.iw-reveal'), show);
    });
    doc.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (block.classList.contains('iw-reveal')) { show(block); }
      each(block.querySelectorAll('.iw-reveal'), show);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
